/* Rootix mobile auto-rotating carousel.
   Activates only on mobile (<750px). Enhances any element marked with
   [data-rx-carousel] inside [data-rx-section]. Touch/scroll-snap aware. */
(function () {
  if (window.__rxCarouselInit) return;
  window.__rxCarouselInit = true;

  function initSection(section) {
    if (section.__rxBound) return;
    section.__rxBound = true;
    var track = section.querySelector('[data-rx-carousel]');
    var dotsContainer = section.querySelector('[data-rx-dots]');
    if (!track) return;
    var slides = Array.prototype.filter.call(track.children, function (el) {
      return !el.hasAttribute('data-rx-skip');
    });
    if (slides.length < 2) return;

    var current = 0;
    var autoplay;
    var interval = parseInt(section.getAttribute('data-rx-interval') || '4500', 10);

    var dots = [];
    if (dotsContainer) {
      dotsContainer.innerHTML = '';
      slides.forEach(function (_, i) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'rx-dot' + (i === 0 ? ' is-active' : '');
        btn.setAttribute('aria-label', 'Slide ' + (i + 1));
        btn.addEventListener('click', function () {
          stop();
          goTo(i);
          setTimeout(start, 6000);
        });
        dotsContainer.appendChild(btn);
        dots.push(btn);
      });
    }

    function update(idx) {
      current = idx;
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });
    }

    function goTo(idx) {
      var slide = slides[idx];
      if (!slide) return;
      track.scrollTo({
        left: slide.offsetLeft - track.offsetLeft,
        behavior: 'smooth'
      });
      update(idx);
    }

    function start() {
      stop();
      autoplay = setInterval(function () {
        goTo((current + 1) % slides.length);
      }, interval);
    }
    function stop() {
      if (autoplay) clearInterval(autoplay);
    }

    track.addEventListener('scroll', function () {
      var w = track.clientWidth;
      var idx = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / w)));
      if (idx !== current) update(idx);
    }, { passive: true });

    track.addEventListener('touchstart', stop, { passive: true });
    track.addEventListener('touchend', function () {
      setTimeout(start, 4000);
    }, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop();
      else start();
    });

    var mq = window.matchMedia('(min-width: 750px)');
    function handleMq() {
      if (mq.matches) {
        stop();
      } else {
        start();
      }
    }
    if (mq.addEventListener) mq.addEventListener('change', handleMq);
    else mq.addListener(handleMq);
    handleMq();
  }

  function initAll() {
    document.querySelectorAll('[data-rx-section]').forEach(initSection);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:select', initAll);
})();
